import { Component, OnInit, Input, inject } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { QRCodeComponent } from "angularx-qrcode";
import { ModalStateService } from "src/app/services/modal-service/modal-state.service";

@Component({
	selector: "app-privacy-policy-modal",
	templateUrl: "./privacy-policy-modal.page.html",
	styleUrls: ["./privacy-policy-modal.page.scss"],
	imports: [IonicModule, TranslateModule, QRCodeComponent],
})
export class PrivacyPolicyModalPage implements OnInit {
	message: string;
	@Input() header: string;
	@Input() url: string = "https://nettask.de";
	modalState: ModalStateService;
	constructor() {
		this.modalState = inject(ModalStateService);
	}

	ngOnInit() {
		const state = this.modalState.getCurrentState();
		this.message = state.message;
	}

	close(accepted: boolean) {
		this.modalState.triggerDismiss("accepted", accepted);
	}
}
